import { useRef, useState, useEffect, useCallback } from 'react';
import './Carousel.css';

export default function Carousel({ children }) {
  const trackRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const update = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const overflow = el.scrollWidth > el.clientWidth + 8;
    setHasOverflow(overflow);
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
  }, []);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    update();
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      el.removeEventListener('scroll', update);
      ro.disconnect();
    };
  }, [update]);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('.course-card');
    const gap = parseInt(getComputedStyle(el).columnGap) || 20;
    const amount = (card ? card.offsetWidth + gap : 320) * dir;
    el.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <div className={`carousel${hasOverflow ? ' carousel--overflow' : ''}`}>
      {/* viewport clips the scrolling track; buttons live outside it so they aren't clipped */}
      <div className="carousel__viewport">
        <div className="carousel__track" ref={trackRef}>
          {children}
        </div>
      </div>

      {hasOverflow && (
        <>
          <button
            className="carousel__btn carousel__btn--prev"
            onClick={() => scroll(-1)}
            disabled={!canScrollLeft}
            aria-label="Scroll left"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <button
            className="carousel__btn carousel__btn--next"
            onClick={() => scroll(1)}
            disabled={!canScrollRight}
            aria-label="Scroll right"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>

          <div className="carousel__fade carousel__fade--left" aria-hidden="true" style={{ opacity: canScrollLeft ? 1 : 0 }} />
          <div className="carousel__fade carousel__fade--right" aria-hidden="true" style={{ opacity: canScrollRight ? 1 : 0 }} />
        </>
      )}
    </div>
  );
}
